import React, { useState, lazy, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ROLES } from 'globalconfig/constants/keys';
import RenderComponent from './RenderComponent';
import { objectArrayFromDiffFields, objectArrayFromMultipleFields, hasRestrictedRole } from 'globalutils/fmUtils';
import { COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ViewForm = ({ changeRequest, hasApiStatus, callback, history, list, setPagination }) => {
  const token = getCookie(COOKIE_AUTH_DETAILS);
  const [validationError, setValidationError] = useState('');
  const [dateValidationError, setDateValidationError] = useState('');

  const { drivers, vehicles, mechanics } = list || {};

  const { userList, vehicleList, mechanicList } = useMemo(() => {
    const userList = objectArrayFromMultipleFields(drivers, 'id', ['firstName', 'lastName']);
    const vehicleList = objectArrayFromDiffFields(vehicles, 'vehicleId', 'vin')?.map((o) => ({
      ...o,
      label: `...${o?.label.substr(o?.label?.length - 8)}`,
    }));
    const mechanicList = objectArrayFromMultipleFields(mechanics, 'id', ['firstName', 'lastName']);

    return { userList, vehicleList, mechanicList };
  }, [drivers, vehicles, mechanics]);

  const handleSubmit = (fields) => {
    setDateValidationError('');
    if (
      fields.driverId?.value ||
      fields.vehicleId?.value ||
      fields.startDate ||
      fields.endDate ||
      fields.companyName ||
      fields.mechanicId?.value
    ) {
      if (fields.startDate && moment(fields.endDate).diff(fields.startDate, 'days') < 0) {
        setDateValidationError('Date To should not be less than Date From');
      } else {
        setValidationError('');
        const finalData = {
          driverId: hasRestrictedRole([ROLES.DRIVER]) ? token?.userId : fields.driverId?.value || null,
          vehicleId: fields.vehicleId?.value || null,
          startDate: fields.startDate ? fields.startDate.replaceAll('/', '-') : null,
          endDate: fields.endDate ? fields.endDate.replaceAll('/', '-') : null,
          companyName: fields.companyName || null,
          mechanicId: hasRestrictedRole([ROLES.MECHANIC]) ? token?.userId : fields.mechanicId?.value || null,
        };
        Object.keys(finalData).forEach((key) => finalData[key] === null && delete finalData[key]);
        setPagination(true);
        changeRequest({ ...finalData });
      }
    } else {
      setValidationError('Please select atleast one filter');
    }
  };

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{
          driverId: '',
          vehicleId: null,
          startDate: null,
          endDate: null,
          companyName: null,
          mechanicId: '',
        }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        handleOnCancel={() => {
          setPagination(true);
          changeRequest();
          setValidationError('');
        }}
        customProps={{
          history,
          callback,
          hasApiStatus,
          vehicleList,
          userList,
          validationError,
          mechanicList,
          dateValidationError,
          setDateValidationError,
        }}
      />
    </>
  );
};

ViewForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default ViewForm;
